import { makeStyles, shorthands } from "@griffel/react";

export const useActionButtonStyles = makeStyles({
  draftButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    ...shorthands.padding("4px", "8px"),
    ...shorthands.borderRadius("4px"),
    ...shorthands.flex("none"),
    ...shorthands.border("1px", "solid", "#357C7C"),
    columnGap: "2px",
    boxShadow: "none",
    outline: "none",
    backgroundColor: "transparent",
    minHeight: "36px",
    minWidth: "unset",
    ":focus": {
      ...shorthands.border("2px", "solid", "#357C7C"),
      outline: "none",
      boxShadow: "none",
    },
    ":focus-visible": {
      ...shorthands.border("2px", "solid", "#357C7C"),
      outline: "none",
      boxShadow: "none",
    },
    ":hover": {
      ...shorthands.border("1px", "solid", "#357C7C"),
      backgroundColor: "rgba(53, 124, 124, 0.04)",
    },
  },
  draftButtonText: {
    fontFamily: "Segoe UI",
    fontSize: "12px",
    color: "#357C7C",
    whiteSpace: "nowrap",
  },
  iconActionButton: {
    flexShrink: 0,
    minWidth: "36px",
    minHeight: "36px",
    ...shorthands.padding("0px"),
    ...shorthands.border("1px", "solid", "#357C7C"),
    color: "#357C7C",
    backgroundColor: "transparent",
    ":hover": {
      backgroundColor: "rgba(53, 124, 124, 0.04)",
    },
  },
  viewActionButton: {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    ...shorthands.gap("4px"),
    ...shorthands.padding("2px", "6px"),
    ...shorthands.borderRadius("4px"),
    ...shorthands.border("1px", "solid", "#E0E0E0"),
    backgroundColor: "#FFFFFF",
    cursor: "pointer",
    fontFamily: "Segoe UI",
    fontSize: "12px",
    color: "#333333",
    flexShrink: 0,
    ":hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  viewActionIcon: {
    width: "14px",
    height: "14px",
    color: "#357C7C",
  },
});
